import type { BimcCalculationLimitedCostData, ConstructionTypeData, UercCalculationSeasonData } from 'gql/graphql';

import type { ICellRendererParams } from 'ag-grid-community';
import type { FC } from 'react';

import { CHAPTER_RECORDS } from '../commonData';

import { BimCalculationLimitedRowMenu } from './BimCalculationLimitedRowMenu';

interface IBimMenuCellRenderer extends ICellRendererParams<BimcCalculationLimitedCostData> {
    constructionTypes: ConstructionTypeData[];
    calculationId: number;
    constructionTypeId: number;
    onOperationSuccess?: (id?: number) => void;
    costRounding: number;
    isCalculationCompleted: boolean;
    seasons?: UercCalculationSeasonData[] | null;
}

export const cellClass = ({ data }: any) => (Object.keys(CHAPTER_RECORDS).includes(data.id) ? 'sub-header' : '');

export const notSubHeaderRow = (row: any) => !Object.keys(CHAPTER_RECORDS).includes(row.id);

export const BimMenuCellRenderer: FC<IBimMenuCellRenderer> = (props) => {
    const {
        data,
        constructionTypeId,
        calculationId,
        constructionTypes,
        onOperationSuccess,
        costRounding,
        isCalculationCompleted,
        seasons,
    } = props;

    return notSubHeaderRow(data) ? (
        <BimCalculationLimitedRowMenu
            row={data}
            onOperationSuccess={onOperationSuccess}
            constructionTypes={constructionTypes}
            constructionTypeId={constructionTypeId}
            calculationId={calculationId}
            costRounding={costRounding}
            isCalculationCompleted={isCalculationCompleted}
            seasons={seasons}
        />
    ) : (
        <span />
    );
};

BimMenuCellRenderer.displayName = 'BimMenuCellRenderer';
